import { useState } from "react";

const improvementOptions = [
  {
    value: "BETTER_SLEEP",
    label: "Better Sleep",
    image: "/assets/screen5-assets/Better_Sleep.webp",
  },
  {
    value: "BETTER_BREATHING",
    label: "Better Breathing",
    image: "/assets/screen5-assets/better_Breathing.webp",
  },
  {
    value: "LESS_ANXIETY",
    label: "Less Anxiety",
    image: "/assets/screen5-assets/Less_Anxiety.webp",
  },
  {
    value: "REDUCED_PAIN",
    label: "Reduced Pain",
    image: "/assets/screen5-assets/Reduced_Pain.webp",
  },
  {
    value: "BETTER_MOOD",
    label: "Better Mood",
    image: "/assets/screen5-assets/Better_Mood.webp",
  },
  {
    value: "IMPROVED_FOCUS",
    label: "Improved Focus",
    image: "/assets/screen5-assets/Improve_Focus.webp",
  },
  {
    value: "MORE_ENERGY",
    label: "More Energy",
    image: "/assets/screen5-assets/More_Energy.webp",
  },
  {
    value: "EMOTIONALLY_LIGHTER",
    label: "Emotionally Lighter",
    image: "/assets/screen5-assets/Emotionally_Lighter.webp",
  },
  {
    value: "MORE_HOPEFUL",
    label: "More Hopeful",
    image: "/assets/screen5-assets/More_Hopeful.webp",
  },
  {
    value: "REDUCED_OVERTHINKING",
    label: "Reduced Overthinking",
    image: "/assets/screen5-assets/Reduce_Overthinking.webp",
  },
  {
    value: "NO_CHANGE",
    label: "No Change",
    image: "/assets/screen5-assets/No_Change.webp",
  },
  {
    value: "OTHER",
    label: "Other",
    image: "/assets/screen5-assets/Others.webp",
  },
];

const ScreenFive = ({
  selectedImprovements,
  improvementOther,
  onImprovementToggle,
  onImprovementOtherChange,
}) => {
  const [saveMessage, setSaveMessage] = useState("");
  const otherSelected = selectedImprovements.includes("OTHER");

  function handleSave() {
    setSaveMessage("Your improvement selections have been saved.");
  }

  return (
    <section className="screen-five" aria-labelledby="screen-five-title">
      <h1 className="visually-hidden" id="screen-five-title">
        Today&rsquo;s Improvements
      </h1>

      <aside className="screen-five__intro left-side" aria-hidden="true">
        <div className="screen-five__intro-title">
          <strong>Today&rsquo;s</strong>
          <span>Improvements</span>
        </div>
        <img
          className="screen-five__intro-divider"
          src="/assets/screen4-assets/line.webp"
          alt=""
        />
        <p>Select all that apply</p>
      </aside>

      <div className="content-side">
        <div className="screen-five__main main-content">
        <fieldset className="improvement-fieldset">
          <legend className="visually-hidden">
            Select all improvements that apply
          </legend>
          <div className="improvement-grid">
            {improvementOptions.map((improvement) => {
              const selected = selectedImprovements.includes(improvement.value);

              return (
                <label
                  className={`improvement-option${selected ? " is-selected" : ""}`}
                  key={improvement.value}
                >
                  <input
                    type="checkbox"
                    name="improvements[]"
                    value={improvement.value}
                    checked={selected}
                    onChange={() => onImprovementToggle(improvement.value)}
                  />
                  <span className="improvement-option__check" aria-hidden="true">
                    {selected ? "\u2713" : ""}
                  </span>
                  <img src={improvement.image} alt="" aria-hidden="true" />
                  <span className="improvement-option__label">
                    {improvement.label}
                  </span>
                </label>
              );
            })}
          </div>
        </fieldset>

        {otherSelected && (
          <div className="improvement-other-field">
            <label htmlFor="improvement-other">Please tell us more</label>
            <input
              id="improvement-other"
              name="improvement_other"
              type="text"
              placeholder="Optional note..."
              value={improvementOther}
              onChange={(event) =>
                onImprovementOtherChange(event.target.value)
              }
            />
          </div>
        )}

        <input
          className="improvement-save"
          type="button"
          name="ui_action"
          value={"\u2667  Save Improvements"}
          onClick={handleSave}
        />
        <p className="improvement-save-status" role="status" aria-live="polite">
          {saveMessage}
        </p>
        </div>
      </div>
    </section>
  );
}

export default ScreenFive;
